export const osnMoreInfoNoCircleIcon = {
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 18L12 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
<circle cx="12" cy="7" r="1" fill="currentColor"/>
</svg>`,
  name: 'more-info-no-circle',
};
